import { IconComponent } from './types';

const GlobeIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      d="M7 0C3.136 0 0 3.136 0 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7ZM4.2 10.85a1.75 1.75 0 1 1 .001-3.501A1.75 1.75 0 0 1 4.2 10.85ZM5.25 4.2a1.75 1.75 0 1 1 3.501.001A1.75 1.75 0 0 1 5.25 4.2Zm4.55 6.65a1.75 1.75 0 1 1 .001-3.501A1.75 1.75 0 0 1 9.8 10.85Z"
      fill="#0091FF"
    />
  </svg>
);

export default GlobeIcon;
